import { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Table } from "react-bootstrap";
import { storeOrderServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeOrderServices";
import { FiPlusSquare } from "react-icons/fi";
import { FaTrash, FaXmark } from "react-icons/fa6";

const AddOrder = ({ getStoreOrderList, setAddNewProduct }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewStoreOrder = async () => {
    setLoader(true);
    let userData = {};
    userData.name = name;
    userData.description = description;
    let data = await storeOrderServices.addNewStoreOrder(userData);
    if (data?.statusCode === 200) {
      getStoreOrderList();
      clearData();
    }
    setLoader(false);
  };

  const clearData = () => {
    setName("");
    setDescription("");
    setLoader(false);
  };

  const [items, setItems] = useState([
    {
      id: Date.now(),
      name: "New Product",
      sku: "16",
      qty: 1,
      price: 10,
      image:
        "https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg",
      url: "http://localhost:3000/home",
    },
  ]);

  const [discount, setDiscount] = useState(100);
  const [couponDiscount, setCouponDiscount] = useState(50);
  const tax = 50;

  const addItem = () => {
    setItems([
      ...items,
      {
        id: Date.now(),
        name: "",
        sku: "",
        qty: 1,
        price: 20,
        image: "https://rukminim2.flixcart.com/image/612/612/xif0q/lipstick/a/1/7/-original-imahjru97xuzmryz.jpeg",
        url: "http://localhost:3000/home",
      },
    ]);
  };

  const removeItem = (id) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const updateItem = (id, field, value) => {
    setItems(
      items.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };

  const subtotal = items.reduce((sum, item) => sum + item.qty * item.price, 0);
  const total = subtotal - discount - couponDiscount + tax;


  useEffect(() => {
    setName("");
    setDescription("");
    setLoader(false);
  }, []);

  return (
    <>
      <div className="h-100 d-flex flex-column w-100">
        <div className="bg-white border-bottom py-2 px-3">
          <div className="hstack justify-content-between">
            <h6 className="fw-semibold m-0">Add New Order</h6>
            <button
              className="icon-btn danger"
              title="Close"
              onClick={() => setAddNewProduct("")}
            >
              <FaXmark />
            </button>
          </div>
        </div>
        <div className="flex-grow-1 overflow-auto bg-light">
          <Container
            fluid
            className="border-end overflow-auto py-2"
            style={{ height: "calc(100vh - 105px)" }}
          >
            <Row>
              <Form.Group as={Col} md={12} className="mb-3">
                <Form.Label>
                  Customer <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select>
                  <option value={""}>Select Customer</option>
                </Form.Select>
              </Form.Group>
              <Form.Group as={Col} md={12} className="mb-3">
                <div className="hstack justify-content-between gap-2 mb-2">
                  <Form.Label className="m-0">
                    Items <span className="text-danger">*</span>{" "}
                    <FiPlusSquare onClick={addItem} className="CP" title="Add Items" />
                  </Form.Label>
                  <div className="hstack gap-2">
                    <Button size="sm">Add Coupon</Button>
                    <Button size="sm">Add Discount</Button>
                  </div>
                </div>
                <Table
                  hover
                  className="contacts-table mb-0"
                  style={{ verticalAlign: "middle" }}
                >
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>SKU</th>
                      <th width="120">Qty</th>
                      <th width="120">Price</th>
                      <th width="120">Total</th>
                      <th width="50"></th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.map((item) => (
                      <tr key={item.id}>
                        <td>
                          <div className="d-flex gap-2">
                              <img
                                src={item.image}
                                width={30}
                                height={30}
                                alt=""
                              />
                            <div>
                              <div className="fw-medium">New Product</div>
                              <small className="text-muted">
                                {item.url}
                              </small>
                            </div>
                          </div>
                        </td>

                        <td>16</td>
                        <td>
                          <Form.Control
                            type="number"
                            size="sm"
                            value={item.qty}
                            min={1}
                            onChange={(e) =>
                              updateItem(
                                item.id,
                                "qty",
                                Number(e.target.value),
                              )
                            }
                          />
                        </td>
                        <td>{item.price}</td>

                        <td className="fw-semibold">
                          ${item.qty * item.price}
                        </td>

                        <td className="text-center">
                          <FaTrash
                            className="text-danger CP"
                            onClick={() => removeItem(item.id)}
                          />
                        </td>
                      </tr>
                    ))}

                    {/* Invoice Summary */}
                    <tr className="border-bottom-0">
                      <td colSpan={4} className="text-end">
                        Subtotal
                      </td>
                      <td colSpan={2} className="fw-semibold">
                        ${subtotal}
                      </td>
                    </tr>

                    <tr className="border-bottom-0">
                      <td colSpan={4} className="text-end">
                        Discount
                      </td>
                      <td colSpan={2} className="text-danger">
                        -${discount}
                      </td>
                    </tr>

                    <tr className="border-bottom-0">
                      <td colSpan={4} className="text-end">
                        Coupon Discount
                      </td>
                      <td colSpan={2} className="text-danger">
                        -${couponDiscount}
                      </td>
                    </tr>

                    <tr className="border-bottom-0">
                      <td colSpan={4} className="text-end">
                        Tax
                      </td>
                      <td colSpan={2} className="text-success">
                        +${tax}
                      </td>
                    </tr>

                    <tr className="table-light">
                      <td colSpan={4} className="text-end fw-bold">
                        Grand Total
                      </td>
                      <td colSpan={2} className="fw-bold text-success fs-6">
                        ${total}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Form.Group>
              <div className="d-flex justify-content-end gap-2 mt-3">
                <Button style={{ fontSize: 12 }} variant="light">
                  Cancel
                </Button>
                <Button
                  disabled={!name || !description || loader}
                  onClick={addNewStoreOrder}
                  style={{ fontSize: 12 }}
                >
                  Save
                </Button>
              </div>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default AddOrder;
